import styled, { CSSObject } from '@emotion/styled'
import { useAppContent, useShop } from 'shop/hooks'

const SplashImage = () => {
  const { splashImage } = useAppContent()
  const { partner } = useShop()
  const { seo } = partner || {}
  const { tagline } = seo || {}
  const { name: partnerName } = partner || {}

  const altText = tagline ? `${partnerName} - ${tagline}` : partnerName

  return (
    <Container data-testid='splash-image'>
      <Image src={splashImage} alt={altText || ''} />
    </Container>
  )
}

const Image = styled.img(
  (): CSSObject => ({
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  })
)

const Container = styled.div(() => ({
  height: '100%'
}))

export default SplashImage
